import React, { useState } from 'react'
import { arrayOf, shape, string } from 'prop-types'

import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import Markdown from 'components/atoms/MarkdownContent'
import SectionTitle from 'components/atoms/SectionTitle'
import FAQ from 'components/molecules/FAQ'

import config from 'config'

const { assets_url: assetsUrl } = config

const ScholarshipFAQ = ({
  faqData: {
    title,
    items: faqs,
  },
}) => {
  const initialState = () => faqs.map((faq, idx) => ({
    ...faq,
    active: idx === 0,
    answer: <Markdown content={faq.answer} className="scholarship-faqs__answer"/>,
  }))
  const [faqsList, setFaqs] = useState(initialState())

  const toggleAnswer = (id) => {
    const newFaqs = faqsList.map(faq => (
        faq.id === id ? { ...faq, active: !faq.active } : { ...faq, active: false }
      )
    )
    setFaqs(newFaqs)
  }

  return (
    <div id="faqs" className="scholarship-faqs">
      <SectionContainer
        paddingTop={120}
        paddingBottom={120}
        backgroundColor="#0fc3c4"
      >
        <Container>
          <SectionTitle title={title || 'Informasi Penting'} />
        </Container>
        <Container mobileFull>
          {
            faqsList.map(faq => (
              <FAQ
                question={faq.question}
                answer={faq.answer}
                active={faq.active}
                key={`scholarship-faq-itm-${faq.id}`}
                onClick={() => toggleAnswer(faq.id)}
              />
            ))
          }
        </Container>
      </SectionContainer>
      <style jsx>
        {`
          .scholarship-faqs {
            :global(h2) {
              color: #fff !important;
            }
            :global(.campus-section) {
              background-image: url('${assetsUrl}/assets/img/polka_bg.svg'), url('${assetsUrl}/assets/img/polka_bg.svg');
              background-repeat: no-repeat;
              background-position: bottom 0 left 0,top 10% right 0;
              background-blend-mode: soft-light;
              background-size: 30%, 20%;
            }
            :global(&__answer) {
              :global(p) {
                margin: 0 !important;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

ScholarshipFAQ.propTypes = {
  faqData: shape({
    title: string,
    faqs: arrayOf(shape({
      id: string,
      question: string,
      answer: string,
    })),
  }),
}

export default ScholarshipFAQ
